export const frequentlyQuestion = [
  {
    question: 'What are the different types of negative marks?',
    answer:
      'Negative marks on credit reports can include late payments, charge-offs, collections, foreclosures, bankruptcies, repossessions, and tax liens, among others.',
  },
  {
    question: 'How long do negative marks stay on my credit report?',
    answer:
      'With some exceptions, negative marks stay on your credit report for seven years. Bankruptcies can stay on your report for up to 10 years. Tax liens may remain for up to 15 years.',
  },
  {
    question: 'Can I remove negative marks from my credit report?',
    answer:
      'Sometimes it is possible to remove negative marks from your credit report. If there is an error or incorrect information, you can dispute it with the credit bureaus. Some creditors may be willing to remove negative marks if you negotiate with them to make payments or settle for less money.',
  },
  {
    question: 'What is the impact of negative marks on my credit score?',
    answer:
      'Negative marks can significantly lower your credit score. They indicate a history of missed or late payments, high levels of debt, or other financial problems. The severity of the impact depends on the type of negative mark and its age.',
  },
];
